/**
 * The signature move: a copy of the sticker peels off the sheet and lands on
 * the Bag tab. Purely decorative; skipped under reduced motion.
 */
export function flyToBag(source: Element | null, imageUrl: string | null, face = "#FF4F2E") {
  const bag = document.querySelector<HTMLElement>("[data-bag-target]");
  if (!source || !bag) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const bump = () => {
    bag.classList.remove("bump");
    void bag.offsetWidth;
    bag.classList.add("bump");
  };
  if (reduce) return bump();

  const from = source.getBoundingClientRect();
  const to = bag.getBoundingClientRect();
  const size = Math.min(from.width, from.height, 220);
  const el = document.createElement("div");
  el.className = "flyer";
  el.style.width = `${size}px`;
  el.style.height = `${size}px`;
  el.style.left = `${from.left + from.width / 2 - size / 2}px`;
  el.style.top = `${from.top + from.height / 2 - size / 2}px`;
  el.style.backgroundColor = face;
  if (imageUrl) el.style.backgroundImage = `url("${imageUrl.replace(/"/g, "%22")}")`;
  document.body.appendChild(el);

  const dx = to.left + to.width / 2 - (from.left + from.width / 2);
  const dy = to.top + to.height / 2 - (from.top + from.height / 2);
  const anim = el.animate(
    [
      { transform: "translate(0,0) rotate(0deg) scale(1)", offset: 0 },
      { transform: "translate(0,-28px) rotate(-10deg) scale(1.04)", offset: 0.22 },
      {
        transform: `translate(${dx}px, ${dy}px) rotate(24deg) scale(${24 / size})`,
        opacity: 0.6,
        offset: 1,
      },
    ],
    { duration: 720, easing: "cubic-bezier(0.5, 0, 0.2, 1)" },
  );
  anim.onfinish = () => {
    el.remove();
    bump();
  };
}
